// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import type { SchemaMigration } from '../types'
import { migration as baseline } from './001-baseline'

/** All contentpieces migrations in version order. */
export const contentpiecesMigrations: SchemaMigration[] = [baseline]
